import { useEffect, useState } from 'react';

export const useMousePosition = () => {
    const [scrollPosition, setScrollPosition] = useState(window.scrollY);

    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const updateMousePosition = (event) => {
            setMousePosition({ x: event.clientX, y: event.clientY });
        };

        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };

        window.addEventListener('mousemove', updateMousePosition);
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('mousemove', updateMousePosition);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [mousePosition.x]);

    return { mousePosition, scrollPosition };
};
